export default __webpack_public_path__ + "static/media/aws.a11e49d6.svg";